import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { AdminAuthProvider } from './lib/auth'
import { ThemeProvider } from './lib/theme'
import './index.css'

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, err: unknown): boolean => {
        const status = (err as { response?: { status?: number } } | undefined)?.response?.status
        if (status === 401 || status === 403) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('root element not found')

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <ThemeProvider>
          <AdminAuthProvider>
            <App />
          </AdminAuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
